import { useContext } from "react";
import { ProductMetadataContext } from "./context";

export const useProductMetadataContext = () => {
    const context = useContext(ProductMetadataContext);

    if (context) {
        return context;
    }

    throw new Error(`useProductMetadataContext must be used within the correct provider`);
};
